export default __webpack_public_path__ + "static/media/JomayraHerrera.2d010c9e.jpeg";